import { render, staticRenderFns } from "./ReceptionSlipIssue.vue?vue&type=template&id=1e6ee306&"
import script from "./ReceptionSlipIssue.vue?vue&type=script&lang=ts&"
export * from "./ReceptionSlipIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports